import { BarChart, Bar, Area, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer, LineChart, Line, PieChart, Pie, Cell } from 'recharts';


const LineChartParachute = ({data, xLabel, yLabel, yDisplay}) => {
    return (
            <ResponsiveContainer width="100%" height={300}>
            <LineChart 
                data={data}
                margin={{ top: 20, right: 30, left: 20, bottom: 20 }}
            >
                <CartesianGrid strokeDasharray="3 3" stroke="#f1f5f9" />
                <XAxis 
                dataKey={xLabel} 
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#64748b' }}
                />
                <YAxis 
                axisLine={false}
                tickLine={false}
                tick={{ fontSize: 12, fill: '#64748b' }}
                />
                <Tooltip 
                contentStyle={{
                    backgroundColor: 'rgba(255, 255, 255, 0.95)',
                    backdropFilter: 'blur(10px)',
                    border: 'none',
                    borderRadius: '12px',
                    boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1)',
                }}
                />
                <Legend 
                    wrapperStyle={{ paddingTop: '20px' }}
                />
                <Line 
                    type="monotone" 
                    dataKey={yLabel} 
                    stroke="#4f46e5" 
                    strokeWidth={3}
                    dot={{ fill: '#4f46e5', strokeWidth: 2, r: 5 }}
                    activeDot={{ r: 8, stroke: '#4f46e5', strokeWidth: 3, fill: 'white' }}
                    name={yDisplay}
                />
            </LineChart>
            </ResponsiveContainer>
    );
}
export default LineChartParachute;